import * as React from "react";
import { CardType, ICard } from "./Card";
import { IAppState } from "./App";
import { Stock } from "./Stock";
import { DeckComponent, IDeckSettings } from "./DeckComponent";
import { IDeck} from "./Deck";
import { CardUtil } from "./CardUtil";

interface IInvestigatorSelectorProps {
    appState: IAppState;
    selectInvestigator: (card: ICard) => void;
}
interface IInvestigatorSelectorState {
    selectedCard: ICard;
}
export class InvestigatorSelectorComponent extends React.Component<IInvestigatorSelectorProps, IInvestigatorSelectorState> {
    constructor(props: IInvestigatorSelectorProps) {
        super(props);
        this.state = { selectedCard: null }
    }
    frontDeckComponent: DeckComponent;
    backDeckComponent: DeckComponent;
    cards: ICard[];
    displayCard(card: ICard) {
        this.setState({ selectedCard: card });
    }
    saveCurrentInvestigator() {
        if (!this.isCardAlreadyInUse(this.state.selectedCard)) {
            this.backDeckComponent.setState({ zoomed: false });
            this.frontDeckComponent.setState({ zoomed: false });
            const selectedCard = this.state.selectedCard;
            this.setState({ selectedCard: null });
            this.props.selectInvestigator(selectedCard);
        }
    }
    goBack() {
        this.props.selectInvestigator(null);
    }
    isCardAlreadyInUse(card: ICard): boolean {
        const invs = this.props.appState.scenarioState.investigators;
        for (let i = 0; i < invs.length; i++) {
            if (CardUtil.equals(card, invs[i].card)) {
                return true;
            }
        }
        return false;
    }

    onKeyDown(e: React.KeyboardEvent<HTMLDivElement>) {
        console.log(e.key);
        switch (e.key) {
            case "ArrowUp":
            case "ArrowDown":
                const frontIsZoomed = this.frontDeckComponent.state.zoomed;
                this.backDeckComponent.setState({ zoomed: frontIsZoomed });
                this.frontDeckComponent.setState({ zoomed: !frontIsZoomed });
                e.preventDefault();
                return false;
            case "ArrowRight":
                this.move(1);
                e.preventDefault();
                return false;
            case "ArrowLeft":
                this.move(-1);
                e.preventDefault();
                return false;
            case "Enter":
            if (this.state.selectedCard) {
                this.saveCurrentInvestigator();
                e.preventDefault();
                return false;
                }
                break;

        }
    }
    currentIndex() {
        if (!this.state.selectedCard) return -1;
        for (let i = 0; i < this.cards.length; i++) {
            if (this.cards[i].pack === this.state.selectedCard.pack &&
                this.cards[i].packNumber === this.state.selectedCard.packNumber)
                return i;
        }
        return -1;
    }
    move(pos: number) {
        let indexOf = this.currentIndex();
        indexOf += pos;
        if (indexOf >= this.cards.length)
            indexOf = 0;
        if (indexOf < 0) {
            indexOf = this.cards.length - 1;
        }
        this.setState({ selectedCard: this.cards[indexOf] });
    }

    render() {

        let cards = Stock.getCardsOfType(CardType.Investigator, "");
        cards = cards.filter((c) => {
            var invs = this.props.appState.scenarioState.investigators;
            for (let i = 0; i < invs.length; i++) {
                if (CardUtil.equals(invs[i].card, c)) return false;
            }
            return true;
        });
        this.cards = cards;
        //filter selected card on already selected investigators
        let selectedCard = this.state.selectedCard;
        if (this.isCardAlreadyInUse(selectedCard)) {
            selectedCard = null;
        }
        const investigators = cards.map((c, i) => {
            const cssClasses = "portrait " + CardUtil.getCardCss(c, true);
            return <li key={i} onClick={() => this.displayCard(c)}><div className={cssClasses} /><div className="title">{c.name}</div></li>;
        });
        const title = "Select investigator for player " + (this.props.appState.scenarioState.investigators.length + 1) + "/" + this.props.appState.numberOfPlayers;
        //const faceUpCss = "deck-horizontal " + CardUtil.getCardCss(selectedCard, true);
        //const faceDownCss = "deck-horizontal " + CardUtil.getCardCss(selectedCard, false);
        const frontDeck: IDeck = { cards: [] };
        const backDeck: IDeck = { cards: [] };
        if (selectedCard) {
            const frontCard = ({ ...selectedCard });
            const backCard = ({ ...selectedCard });
            frontCard.faceUp = true;
            backCard.faceUp = false;
            frontDeck.cards.push(frontCard);
            backDeck.cards.push(backCard);
        }
        const deckSettings: IDeckSettings = { toolbar: { flip: false } };
        return (
            <div className="container">
                <div className="col-md-12 p-t-30">
                    <div id="investigatorSelector">
                        <div className="content-box">
                            <h1>{title}</h1>
                            <ul>{investigators}</ul>
                            <div className="bottomRow" onKeyDown={(e) => this.onKeyDown(e)}>
                                <div>
                                    <button onClick={() => this.goBack()}>Back</button>
                                </div>
                                <DeckComponent deck={frontDeck} horizontal={true} settings={deckSettings} ref={(r) => { this.frontDeckComponent = r; }} />
                                <DeckComponent deck={backDeck} horizontal={true} settings={deckSettings} ref={(r) => { this.backDeckComponent = r; }} />
                                <div>
                                    <button onClick={() => this.saveCurrentInvestigator()}>Next</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}